import axios from "axios";
import { setJwtToken } from "config/axiosInstance";
// const URL = "https://devnode.foodonreels.com:3235/api/user/v1/master";
const URL = process.env.REACT_APP_MASTER_URL;
// Helper function to add type=admin to data
const appendAdminType = (data) => {
  return { ...data, type: "admin" };
};
// Batch Listyh
export const BatchApi = async (data) => {
  const endPoint =
    `${URL}master/batch` +
    "?" +
    new URLSearchParams({ ...appendAdminType(data) }).toString();
  return await axios.get(endPoint, setJwtToken());
};
// Delete Account
export const DeletAccountApi = async (data) => {
  const endPoint =
    `${URL}master/delete_account_list` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
// ------------->
export const masterBrandListApi = async (data) => {
  const endPoint =
    `${URL}/tag_brands` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
export const masterCategoriesListApi = async (data) => {
  const endPoint =
    `${URL}/categories` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
// ------------->
export const masterClothingCategoriesListApi = async (data) => {
  const endPoint =
    `${URL}/clothing_categories` +
    "?" +
    new URLSearchParams({ ...data }).toString();

  return await axios.get(endPoint, setJwtToken());
};
// master api for color
export const masterColorApi = async (data) => {
  const endPoint =
    `${URL}/color_list` + "?" + new URLSearchParams({ ...data }).toString();

  return await axios.get(endPoint, setJwtToken());
};
export const masterSizeApi = async (data) => {
  const endPoint =
    `${URL}/size_list` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
